import React, { useEffect, useMemo, useState } from 'react';

function formatCurrency(value) {
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return value ?? '0.00';
  return numeric.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function buildIncludesLabel(items) {
  if (!items?.length) return '';
  return items
    .map((it) => {
      const qty = it?.Qty != null ? Number(it.Qty) : null;
      const name = it?.ItemName || '';
      if (!name) return null;
      if (qty && qty !== 1) return `${name} x${qty}`;
      return name;
    })
    .filter(Boolean)
    .join(', ');
}

function PackageCards({ packages, addToBill, search }) {
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(packages || []);
  }, [packages]);

  const filtered = useMemo(() => {
    const term = (search || '').trim().toLowerCase();
    if (!term) return list;
    return list.filter((p) => {
      const fields = [p.PackageName, p.PackageDescription, buildIncludesLabel(p.items)];
      return fields.some((f) => (f || '').toString().toLowerCase().includes(term));
    });
  }, [list, search]);

  const handleClick = (pkg) => {
    if (!pkg) return;
    addToBill({
      isPackage: true,
      PackageID: pkg.PackageID,
      name: pkg.PackageName,
      ItemName: pkg.PackageName,
      Price: Number(pkg.SellingPrice) || 0,
      sellingPrice: Number(pkg.SellingPrice) || 0,
      packageDescription: pkg.PackageDescription || '',
      packageItems: pkg.items || [],
      ItemCategoryID: 9001,
    });
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', height: '63vh', justifyContent: 'left' }}>
      {filtered.map((pkg) => {
        const includes = buildIncludesLabel(pkg.items);
        return (
          <div key={pkg.PackageID} style={{ width: '160px', backgroundColor: 'white', margin: 5 }}>
            <div style={{ display: 'block', border: '1px solid #ccc', backgroundColor: 'white', borderRadius: 5 }}>
              <div
                onClick={() => handleClick(pkg)}
                style={{
                  border: '1px solid #ccc',
                  padding: '10px',
                  height: '180px',
                  borderRadius: 5,
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  backgroundColor: 'white',
                  justifyContent: 'space-around',
                  cursor: 'pointer',
                }}
              >
                <div style={{ fontWeight: 'bold' }}>Rs.{formatCurrency(pkg.SellingPrice)}</div>
                <div style={{ fontWeight: 'bold', fontSize: 14, textAlign: 'center' }}>
                  {pkg.PackageName}
                </div>
                {pkg.PackageDescription ? (
                  <div style={{ fontSize: 10, color: '#333', textAlign: 'center', maxHeight: 36, overflow: 'hidden' }}>
                    {pkg.PackageDescription}
                  </div>
                ) : null}
                {includes ? (
                  <div style={{ fontSize: 9, color: '#111', textAlign: 'center', maxHeight: 44, overflow: 'hidden' }}>
                    Includes: {includes}
                  </div>
                ) : (
                  <div style={{ fontSize: 9, color: '#666' }}>Includes: -</div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default PackageCards;

